<template>
  <SignUpScreen>
    <StyleQuizIntro class="intro"/>
  </SignUpScreen>
</template>

<script setup>
import SignUpScreen from '@/views/signUp/SignUpScreen.vue'
import StyleQuizIntro from '@/components/styleQuiz/StyleQuizIntro.vue'
</script>

<style scoped lang="scss">
.intro {
  margin: 33px 0 100px 0;
}
.sign-up-screen {
  background: linear-gradient(167.11deg, rgba(133, 13, 84, 0.05) 100%, rgba(172, 153, 164, 0.05) 18.01%);
}
:deep(.sign-up-screen-content) {
  padding: 0px !important;
}
:deep(.background-image-mobile) {
  padding-top: 49px;
}
:deep(.background-image-desktop) {
  padding-top: 80px;
  @media screen and (min-width: 1496px) {
    padding-top: 73px;
  }
}
</style>
